import React from "react";
import ReactDOM from "react-dom";
import { m, LazyMotion, domAnimation, AnimatePresence } from "framer-motion";
import { NavLink, useNavigate } from "react-router-dom";
import { Button } from "ui/components/atoms";
import { useSessionContext } from "ui/context/SessionContext";
import { cx } from "utils/join-classnames";
import { useNotifications } from "ui/context/NotificationsContext";

import { logoutUser } from "core/services";
import { useLivestreamContext } from "ui/context/LivestreamContext";
import $ from "./TrialEndedPopup.module.scss";

const TrialEndedPopup: React.FC = () => {
    const sessionContext = useSessionContext();
    const navigate = useNavigate();
    const livestreamContext = useLivestreamContext();
    const { addNotification } = useNotifications();

    const logout = async () => {
        try {
            if (!sessionContext.session) {
                throw Error("missing session");
            }
            await logoutUser(sessionContext.session.token);
            navigate("/login");
            livestreamContext.removeAll();
            sessionContext.setSession(null);
        } catch (err) {
            addNotification(
                "error",
                "Failed to log out",
                "please try again",
                5000,
            );
        }
    };

    return ReactDOM.createPortal(
        <div className={$.container}>
            <LazyMotion features={domAnimation} strict>
                <AnimatePresence mode="wait">
                    <m.div
                        initial={{ x: 100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: -100 }}
                        className={$.popup}
                    >
                        <h2 className={$.popup__title}>Your trial has ended</h2>
                        <div className={$.popup__body}>
                            Your project&#39;s 30-day trial period has ended,
                            and therefore access has been disabled. Please get
                            in touch with us at{" "}
                            <a href="mailto:info@spot-on.media">
                                info@spot-on.media
                            </a>{" "}
                            if you wish to continue using SpotOn.
                        </div>
                        {sessionContext.userHasMultipleProjects ? (
                            <NavLink to="/projects">
                                <Button
                                    className={cx($.popup__button)}
                                    size="medium"
                                    type="primary"
                                >
                                    Go back
                                </Button>
                            </NavLink>
                        ) : (
                            <NavLink to="/projects">
                                <Button
                                    className={cx($.popup__button)}
                                    onClick={logout}
                                    size="medium"
                                    type="primary"
                                >
                                    Log out
                                </Button>
                            </NavLink>
                        )}
                    </m.div>
                </AnimatePresence>
            </LazyMotion>
            <div className={$.background} />
        </div>,
        document.body,
    );
};

export default TrialEndedPopup;
